import axios from "axios";

export default {
    generateQr(params) {
        const headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
        };
        return axios.post(`${process.env.VUE_APP_BASE_URL}/api/generate-quickpass`, params, {
            headers: headers,
        });
    }
}
